require('../components/slider.js');
require('../components/slider-hero.js');
require('../components/slider-testimonials.js');
require('../components/statistics.js');